import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import findAnnouncements from './state';

const resultsTimeCheck = ({ announcements }, results) => results.filter(
  ({ publishedAt }) => new Date(publishedAt).getTime() > announcements.all.closeTimeStamp,
);

const fetchAnnouncements = withDraft((draft, action) => {
  const item = findAnnouncements(draft, action);
  item.readStatus = states.PENDING;
});

const showAnnouncements = withDraft((draft, action) => {
  const item = findAnnouncements(draft, action);
  item.readStatus = states.SUCCESS;
  item.results = resultsTimeCheck(draft, action.results);
  item.count = resultsTimeCheck(draft, action.results).length;
  item.open = resultsTimeCheck(draft, action.results).length;
});

const closeAnnouncements = withDraft((draft, action) => {
  const item = findAnnouncements(draft, action);
  item.open = !item.open;
  draft.announcements.all.closeTimeStamp = action.date;
  draft.announcements.all.hideForSession = true;
});

const previousAnnouncement = withDraft((draft) => { draft.announcements.all.currentIndex -= 1; });

const nextAnnouncement = withDraft((draft) => { draft.announcements.all.currentIndex += 1; });

export default {
  [actions.CLOSE_ANNOUNCEMENTS]: closeAnnouncements,
  [actions.FETCH_ANNOUNCEMENTS]: fetchAnnouncements,
  [actions.NEXT_ANNOUNCEMENT]: nextAnnouncement,
  [actions.PREVIOUS_ANNOUNCEMENT]: previousAnnouncement,
  [actions.SHOW_ANNOUNCEMENTS]: showAnnouncements,
};
